export const categoryConfigs = {
    "Goods distribution": { color: "black", icon: "truck" },
    "Leisure":            { color: "black", icon: "tree" },
    "Generating stations":{ color: "black", icon: "bolt" },
    "Electric lines":     { color: "black", icon: "plug" },
    "Gas or pipelines related":   { color: "black", icon: "fire" },
    "Highways":           { color: "black", icon: "road" },
    "Airports":           { color: "black", icon: "plane" },
    "Railways":           { color: "black", icon: "train" },
    "Water infrastructure": { color: "black", icon: "tint" },
    "Waste facilities":   { color: "black", icon: "trash" }
};

export const applicationProgressConfig = {
    "Approved": {
        color: "#388E3C"
    },
    "In Progress": {
        color: "#FFA000"
    },
    "Rejected": {
        color: "#D73027"
    },
    "default": {
        color: "black"
    }
}
